import React from 'react'
import { connect } from 'react-redux'
import Loading from '../common/loading'
import { fetchFaqs } from '../../store/actions/faqs'

export class FAQsView extends React.Component {
    componentDidMount() {
        this.props.fetchFaqs()
    }

    render() {
        if (!this.props.faqs) return <Loading />

        return (
            <>
                <h2 className="text-primary">Frequently Asked Questions</h2>
                {this.props.faqs.map((f) => (
                    <div key={f._id} className="mt-4">
                        <p className="text-primary font-weight-bold">
                            {f.question}
                        </p>
                        <p>{f.answer}</p>
                        <div className="border-top my-3 mt-4" />
                    </div>
                ))}
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    faqs: state.faqs.faqsList,
})

export default connect(mapStateToProps, {
    fetchFaqs,
})(FAQsView)
